module.exports = __webpack_public_path__ + "img/the_weeknd.66fb4255.jpg";